export const ALERT_BANNER_TYPES = {
  MAINTENANCE_MODE: 'maintenanceMode',
  NO_LEAD_CADENCE: 'noLeadCadence',
  NYLAS_STOPPED: 'nylasStopped',
  NOT_IN_CHROME: 'notInChrome',
  USER_PAUSED: 'userPaused',
  DIFFERENT_TIME_ZONE: 'differentTimeZone',
  WORKFLOW_NOT_EDITABLE: 'workflowNotEditable',
};
